import { api } from '../api-client.config';
import { useQuery } from '@tanstack/react-query';
import { TeamType } from 'src/types/domain.types';

interface TeamsResponse {
  teams: TeamType[];
}

const getTeams = (): Promise<TeamsResponse> => api.get('/teams');

export const useGetTeamsQuery = () => {
  return useQuery({
    queryKey: ['teams'],
    queryFn: getTeams,
    select: (data: TeamsResponse) => data.teams,
  });
};
